import { NotificationType } from "@/Modules/App/Models/Domain/NotificationType";

import { deleteAccount } from "@/Services/TherapyApi/Users";

import useUserStore from "@/Modules/User/Store";

async function deleteAccountAH(userId: string) {
  const userStore = useUserStore();

  userStore.isLoading = true;
  userStore.notification = null;

  try {
    await deleteAccount(userId);
  } catch (error: unknown) {
    userStore.notification = {
      type: NotificationType.ERROR,
      message: "there_was_an_error_connecting_to_the_server_please_try_again_later",
      code: "generic error",
    };
  } finally {
    userStore.isLoading = false;
  }
}

export default deleteAccountAH;
